import React, { useEffect } from 'react';

/**
 * Overlay de processamento/sucesso/erro ao excluir OS no Board.
 * @param {{ visible: boolean, status: 'loading'|'success'|'error', message?: string, onDismiss?: function }} props
 */
export function BoardOrderDeleteOverlay({ visible, status, message, onDismiss }) {
  useEffect(() => {
    if (!visible || !onDismiss) return;
    if (status === 'success') {
      const t = setTimeout(onDismiss, 2200);
      return () => clearTimeout(t);
    }
    if (status === 'error') {
      const t = setTimeout(onDismiss, 4500);
      return () => clearTimeout(t);
    }
  }, [visible, status, onDismiss]);

  if (!visible) return null;

  const isLoad = status === 'loading';
  const isSuccess = status === 'success';
  const isError = status === 'error';

  return (
    <div
      className="board-order-delete-overlay"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10002,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(15, 23, 42, 0.4)',
        backdropFilter: 'blur(4px)',
      }}
      onClick={onDismiss}
      role="dialog"
      aria-live="polite"
      aria-label={isLoad ? 'Excluindo ordem de serviço' : isSuccess ? 'OS excluída' : 'Erro ao excluir'}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: '12px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.12)',
          padding: '24px 32px',
          minWidth: '280px',
          maxWidth: '90vw',
          textAlign: 'center',
          fontFamily: "'Geist Variable', 'Geist', system-ui, sans-serif",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {isLoad && (
          <>
            <div style={{ marginBottom: '12px' }}>
              <i className="bi bi-arrow-repeat" style={{ fontSize: '28px', color: '#7c4dff', animation: 'spin 0.8s linear infinite' }} aria-hidden />
            </div>
            <div style={{ fontSize: '14px', color: '#475569', fontWeight: 500 }}>Excluindo OS...</div>
          </>
        )}
        {isSuccess && (
          <>
            <div style={{ marginBottom: '12px' }}>
              <i className="bi bi-check-circle-fill" style={{ fontSize: '32px', color: '#10b981' }} aria-hidden />
            </div>
            <div style={{ fontSize: '15px', color: '#0f172a', fontWeight: 600 }}>OS excluída</div>
          </>
        )}
        {isError && (
          <>
            <div style={{ marginBottom: '12px' }}>
              <i className="bi bi-exclamation-circle-fill" style={{ fontSize: '32px', color: '#ef4444' }} aria-hidden />
            </div>
            <div style={{ fontSize: '15px', color: '#0f172a', fontWeight: 600, marginBottom: '4px' }}>Erro ao excluir</div>
            <div style={{ fontSize: '13px', color: '#64748b' }}>{message || 'Tente novamente.'}</div>
          </>
        )}
      </div>
      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}

export default BoardOrderDeleteOverlay;
